import React from 'react';
import {buttonStyle} from './styles';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import withAttribute from './withAttribute';
import {
  CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT,
  CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT,
  DATA_ATTR_LOADING_TEXT,
  DATA_ATTR_NODE_TYPE,
  LOADING_TEXT,
  NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON,
} from '@packages/systems/commerce/constants';

import {
  CommerceCheckoutFormConstraint,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
  SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
} from '@packages/systems/core/constants/SharedConstraintRules';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';

import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const CommerceCheckoutPlaceOrderButton = Atom.createRender((props) => {
  const {attributes, classes, data, generateAttributes} = props;
  const innerHTML = getString(getInPojo(data, ['attr', 'value']));
  const loadingText = getString(getInPojo(data, ['commerce', LOADING_TEXT]));

  return (
    <a
      {...generateAttributes(attributes, classes)}
      {...{
        [DATA_ATTR_LOADING_TEXT]: loadingText,
      }}
    >
      {innerHTML}
    </a>
  );
});

const config = createIntegratedAtom({
  displayName: 'Submit Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  constraints: {
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; } | { ...; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceCheckoutFormConstraint,
      // @ts-expect-error - TS2322 - Type 'string | string[] | UnsafeConstraintEscapeHatch | readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]' is not assignable to type 'string | string[] | UnsafeConstraintEscapeHatch'.
      {is: 'CommerceCartQuickCheckoutActions', rule: 'Forbid'},
    ],
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      ...SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          ...buttonStyle,
          display: 'block',
          borderTopLeftRadius: px(3),
          borderTopRightRadius: px(3),
          borderBottomRightRadius: px(3),
          borderBottomLeftRadius: px(3),
          marginBottom: px(20),
          textAlign: 'center',
        },
      },
    },
  },
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON
  )(CommerceCheckoutPlaceOrderButton),
  fields: {
    attr: withSystem(
      {private: false},
      TRecord({
        href: withSystem(
          {
            private: true,
            defaultValue: '#',
          },
          TText
        ),
        value: withMeta(
          {
            placeholder: 'e.g. ' + CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT,
          },
          withSystem(
            {
              label: 'Button:',
              defaultValue: CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT,
            },
            TText
          )
        ),
      })
    ),
    commerce: TRecord({
      type: withSystem(
        {
          defaultValue: 'place-order-button',
          private: true,
        },
        TText
      ),
      [LOADING_TEXT]: withMeta(
        {
          placeholder: 'e.g. ' + CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT,
        },
        withSystem(
          {
            label: 'Waiting:',
            defaultValue: CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT,
          },
          TText
        )
      ),
    }),
  },
});

export default config;
